import { inwardJobWorkBillAddApi } from "../../api/inwardJobWorkBill/inwardJobWorkBillAddApi"

type PayloadShape = Parameters<typeof inwardJobWorkBillAddApi>[0]

export async function inwardJobWorkBillAddService(payload: PayloadShape, token: string) {
	return await inwardJobWorkBillAddApi(payload, token)
}
